import { useTour } from '@reactour/tour';
import { FC, useCallback, useEffect, useRef } from 'react';
import { useUnmount } from 'react-use';

import { TourParamsProviderProps } from './TourParamsProvider.types';

export const TourParamsProvider: FC<TourParamsProviderProps> = (props) => {
    const { children } = props;

    const { setIsOpen, setCurrentStep, currentStep, steps } = useTour();

    const removeGlobalHandler = useRef<() => void>();
    const nextStepRef = useRef<number | null>(null);

    useEffect(() => {
        const nextStep = currentStep + 1;

        if (nextStep >= steps.length) {
            nextStepRef.current = null;
        } else {
            nextStepRef.current = nextStep;
        }
    }, [currentStep, steps.length]);

    const openTour = useCallback(() => {
        setIsOpen(true);
        removeGlobalHandler.current?.();

        const handleGlobalClick = () => {
            if (nextStepRef.current) {
                setCurrentStep(nextStepRef.current);
            } else {
                setIsOpen(false);
                removeGlobalHandler.current?.();
                removeGlobalHandler.current = undefined;
            }
        };

        window.addEventListener('click', handleGlobalClick, {
            capture: true,
            passive: true,
        });

        removeGlobalHandler.current = () => {
            window.removeEventListener('click', handleGlobalClick, {
                capture: true,
            });
        };
    }, [setCurrentStep, setIsOpen]);

    useUnmount(() => {
        removeGlobalHandler.current?.();
    });

    return children({ openTour });
};

TourParamsProvider.displayName = 'TourParamsProvider';
